package kz.dentalcrm.app.screens.service_categories.list.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface ServiceCategoriesViewSideEffect : ViewSideEffect {
    data class ShowEditCategory(val category: ServiceCategory) : ServiceCategoriesViewSideEffect
}
